import render from 'barnyard/typescript/utils/render';
import AuthApp from './App';
import '../app/styles.jsx';

render(AuthApp);
